export const userConfig = {
  USER_TOKEN: "USER_TOKEN",
  RESET: "RESET",
};

export const modalConfig = {
  OPEN_REFRESH_MODAL: "OPEN_REFRESH_MODAL",
  CLOSE_REFRESH_MODAL: "CLOSE_REFRESH_MODAL",
};
